import { put, call, takeLatest, cps } from 'redux-saga/effects';
import * as types from '../ActionTypes/WorkoutsActionTypes';
import { workout } from '../../BusinessLogic/Network/API/WorkoutApi';
import axios from 'axios';
import { WorkoutActionCreators } from '../ActionCreators/WorkoutsActionCreators';

export class WorkoutSaga {
    static *getById({ meta: { workoutId } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.getById(workoutId));

            yield put(WorkoutActionCreators.getByIdSuccess(response.data));
        } catch (e) {
            console.log({ e });
        }
    }

    static *getStockImage({ meta: { workoutType } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.getWorkoutStockImage(workoutType));

            yield put(WorkoutActionCreators.getWorkoutStockImageSuccess(response.data.image_url));
        } catch (e) {
            console.log(e);
        }
    }

    static *uploadImage({ meta: { file, callback } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.uploadWorkoutImage(file));

            yield put(WorkoutActionCreators.uploadWorkoutImageSuccess(response.file_path));
            if (callback) yield cps(callback(response.file_path));
        } catch (error) {
            yield put(WorkoutActionCreators.uploadWorkoutImageFailed(error));
        }
    }

    static *createWorkout({ meta: { workoutData, callback } }) {
        try {
            const _workout = workout.create();
            yield call(axios, _workout.createWorkout(workoutData));

            yield put(WorkoutActionCreators.createWorkoutSuccess());
            if (callback) yield cps(callback);
        } catch (error) {
            yield put(WorkoutActionCreators.createWorkoutFailed(error));
        }
    }

    static *getPlannedWorkouts({ meta: { userId, offsetId, offsetdate } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.getPlannedWorkouts(userId));

            yield put(WorkoutActionCreators.getPlannedWorkoutsSuccess(response.data));
        } catch (error) {
            yield put(WorkoutActionCreators.getPlannedWorkoutsFailed(error));
        }
    }

    static *getWorkoutsOfTheWeekByDateRange({ meta: { start, end } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.getWorkoutOfTheDayByDateRange(start, end));
            yield put(WorkoutActionCreators.getWorkoutsOfTheDayByDateRangeSuccess(response.data));
        } catch (error) {
            yield put(WorkoutActionCreators.getWorkoutsOfTheDayByDateRangeFailed(error));
        }
    }

    static *addWorkoutOfTheDay({ meta: { workoutData, callback } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.addWorkoutOfTheDay(workoutData));
            yield put(WorkoutActionCreators.addWorkoutOfTheDaySuccess(response));
            if (callback) yield cps(callback());
        } catch (error) {
            yield put(WorkoutActionCreators.addWorkoutOfTheDayFailed(error));
        }
    }

    static *getWorkoutOfTheWeek({ meta: { mondayDate } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.getWorkoutOfTheWeek(mondayDate));
            yield put(WorkoutActionCreators.getWorkoutOfTheWeekSuccess(response.data));
        } catch (error) {
            yield put(WorkoutActionCreators.getWorkoutOfTheWeekFailed(error));
        }
    }

    static *addWorkoutOfTheWeek({ meta: { workoutData, callback } }) {
        try {
            const _workout = workout.create();
            const { data: response } = yield call(axios, _workout.addWorkoutOfTheWeek(workoutData));
            yield put(WorkoutActionCreators.addWorkoutOfTheWeekSuccess(response));
            if (callback) yield cps(callback());
        } catch (error) {
            yield put(WorkoutActionCreators.addWorkoutOfTheWeekFailed(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_WORKOUT_BY_ID_REQUEST, WorkoutSaga.getById);
    yield takeLatest(types.GET_WORKOUT_STOCK_IMAGE_REQUEST, WorkoutSaga.getStockImage);
    yield takeLatest(types.UPLOAD_WORKOUT_IMAGE_REQUEST, WorkoutSaga.uploadImage);
    yield takeLatest(types.CREATE_WORKOUT_REQUEST, WorkoutSaga.createWorkout);
    yield takeLatest(types.GET_PLANNED_WORKOUTS_REQUEST, WorkoutSaga.getPlannedWorkouts);
    yield takeLatest(types.GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_REQUEST, WorkoutSaga.getWorkoutsOfTheWeekByDateRange);
    yield takeLatest(types.GET_WORKOUT_OF_THE_WEEK_REQUEST, WorkoutSaga.getWorkoutOfTheWeek);
    yield takeLatest(types.ADD_WORKOUT_OF_THE_DAY_REQUEST, WorkoutSaga.addWorkoutOfTheDay);
    yield takeLatest(types.ADD_WORKOUT_OF_THE_WEEK_REQUEST, WorkoutSaga.addWorkoutOfTheWeek);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/WorkoutSaga.js